/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Status_PresentInputs */

const en_keyword_optimizer_status_present = /** @type {(inputs: Keyword_Optimizer_Status_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const de_keyword_optimizer_status_present = /** @type {(inputs: Keyword_Optimizer_Status_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const fr_keyword_optimizer_status_present = /** @type {(inputs: Keyword_Optimizer_Status_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const es_keyword_optimizer_status_present = /** @type {(inputs: Keyword_Optimizer_Status_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const it_keyword_optimizer_status_present = /** @type {(inputs: Keyword_Optimizer_Status_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const nl_keyword_optimizer_status_present = /** @type {(inputs: Keyword_Optimizer_Status_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const pl_keyword_optimizer_status_present = /** @type {(inputs: Keyword_Optimizer_Status_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const fi_keyword_optimizer_status_present = /** @type {(inputs: Keyword_Optimizer_Status_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const da_keyword_optimizer_status_present = /** @type {(inputs: Keyword_Optimizer_Status_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const sv_keyword_optimizer_status_present = /** @type {(inputs: Keyword_Optimizer_Status_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

/**
* | output |
* | --- |
* | "Present" |
*
* @param {Keyword_Optimizer_Status_PresentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_status_present = /** @type {((inputs?: Keyword_Optimizer_Status_PresentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Status_PresentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_status_present(inputs)
	if (locale === "fr") return fr_keyword_optimizer_status_present(inputs)
	if (locale === "es") return es_keyword_optimizer_status_present(inputs)
	if (locale === "it") return it_keyword_optimizer_status_present(inputs)
	if (locale === "nl") return nl_keyword_optimizer_status_present(inputs)
	if (locale === "pl") return pl_keyword_optimizer_status_present(inputs)
	if (locale === "fi") return fi_keyword_optimizer_status_present(inputs)
	if (locale === "da") return da_keyword_optimizer_status_present(inputs)
	if (locale === "sv") return sv_keyword_optimizer_status_present(inputs)
	return en_keyword_optimizer_status_present(inputs)
});